// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__t_1cv","containerItemsCenter":"Skeleton_containerItemsCenter__2CrkZ"};